import { defineMessages } from 'utils/intl';

export default defineMessages({
  video: '{productName} - Film Promocyjny',
  traits: '{productName} - Charakterystyka',
  description: '{productName} - Opis',
  attributesDescription: '{productName} - Opis atrybutów',
  specification: '{productName} - Specyfikacja',
  packageContent: '{productName} - Zawartość opakowania',
  documentation: '{productName} - Dokumentacja',
  variants: '{productName} - Warianty',
  articles: '{productName} - Artykuły',
  rating: '{productName} - Ocena',
  accessories: '{productName} - Akcesoria',
  producerPn: 'Kod producenta',
  specificationCopied: 'Skopiowano specyfikację',
  noneValue: 'Brak',
});
